import { Box, Divider } from '@mui/material';
import { RightSidebarNavigation } from 'app/components/Sidebar/SidebarPanel/RightSidebarNavigation';
import { RightMenuNavigation } from 'app/enums';
import { RightSidebarContext } from 'app/providers';
import { GlobalChat } from 'modules/global-chat/components';
import { LeaderboardsCarousel } from 'modules/leaderboards/components/LeaderboardsCarousel';
import React, { FC, ReactElement, useContext, useMemo } from 'react';
import { NotificationsListContainer } from 'modules/notifications/components/NotificationsList';
import { Players } from 'modules/users/components/Players';
import { Inbox } from 'modules/chat/components/Inbox';
import { useStyles } from './SidebarPanelRight.styles';

export const SidebarPanelRight: FC = () => {
  const { classes } = useStyles();
  const { activeTab } = useContext(RightSidebarContext);

  const content = useMemo<Record<string, ReactElement>>(
    () => ({
      [RightMenuNavigation.Notification]: <NotificationsListContainer />,
      [RightMenuNavigation.GlobalChat]: <GlobalChat />,
      [RightMenuNavigation.Messages]: <Inbox />,
      [RightMenuNavigation.Players]: <Players />,
    }),
    []
  );

  return (
    <Box className={classes.root}>
      <Box className={classes.navigation}>
        <RightSidebarNavigation />

        {activeTab === RightMenuNavigation.Home ? null : (
          <Box className={classes.content}>{content[activeTab]}</Box>
        )}
      </Box>
      <Box className={classes.leaderboardContainer}>
        <Divider />
        <LeaderboardsCarousel />
      </Box>
    </Box>
  );
};
